import { render, staticRenderFns } from "./MemberAskHistory.vue?vue&type=template&id=c368d836&"
import script from "./MemberAskHistory.vue?vue&type=script&lang=js&"
export * from "./MemberAskHistory.vue?vue&type=script&lang=js&"
import style0 from "./MemberAskHistory.vue?vue&type=style&index=0&id=c368d836&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c368d836')) {
      api.createRecord('c368d836', component.options)
    } else {
      api.reload('c368d836', component.options)
    }
    module.hot.accept("./MemberAskHistory.vue?vue&type=template&id=c368d836&", function () {
      api.rerender('c368d836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/members/member-ask/MemberAskHistory.vue"
export default component.exports